import React from "react";
import { Document, Page, Text, View, StyleSheet, Font } from "@react-pdf/renderer";

// (Optionnel) si tu veux une police custom, sinon laisse Helvetica par défaut.

const styles = StyleSheet.create({
  page: { padding: 28, fontSize: 10, fontFamily: "Helvetica" },
  title: { textAlign: "center", fontSize: 18, fontWeight: "bold" },
  subtitle: { textAlign: "center", marginTop: 6, fontSize: 11 },
  row: { flexDirection: "row", alignItems: "center" },
  line: { borderBottomWidth: 1, borderBottomColor: "#000", flexGrow: 1, marginLeft: 6 },
  sectionHeader: { marginTop: 14, flexDirection: "row", alignItems: "flex-end" },
  sectionTitle: { fontSize: 12, fontWeight: "bold" },
  sectionRule: { borderBottomWidth: 1, borderBottomColor: "#000", flexGrow: 1, marginLeft: 8, marginBottom: 2 },
  label: { width: 140 },
  smallLabel: { width: 60 },
  field: { borderBottomWidth: 1, borderBottomColor: "#000", flexGrow: 1, minHeight: 14, paddingBottom: 1 },
  box: { borderWidth: 1, borderColor: "#000", padding: 6, marginTop: 10 },
  checkbox: { width: 12, height: 12, borderWidth: 1, borderColor: "#000", marginRight: 6, alignItems: "center", justifyContent: "center" },
  checkboxMark: { fontSize: 10, marginTop: -1 },
  table: { borderWidth: 1, borderColor: "#000", marginTop: 10 },
  tr: { flexDirection: "row" },
  th: { fontWeight: "bold", borderRightWidth: 1, borderRightColor: "#000", padding: 6 },
  td: { borderRightWidth: 1, borderRightColor: "#000", padding: 6 },
  cellCode: { width: 150 },
  cellDesc: { width: 290 },
  cellOui: { width: 45, alignItems: "center" },
  cellQty: { flexGrow: 1 },
  hr: { borderBottomWidth: 1, borderBottomColor: "#000", marginTop: 8 },
  red: { color: "red", fontWeight: "bold" },
  greenBox: { borderWidth: 2, borderColor: "#5aa04b", marginTop: 10 },
  greenInner: { borderColor: "#5aa04b" },
});

const Check = ({ checked }) => (
  <View style={styles.checkbox}>
    {checked ? <Text style={styles.checkboxMark}>X</Text> : null}
  </View>
);

const LineField = ({ value }) => <Text style={styles.field}>{value || ""}</Text>;

export default function DapPdf({ data }) {
  const d = data;

  return (
    <Document>
      {/* PAGE 1 */}
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>DEMANDE D’ACCEPTATION</Text>
        <Text style={[styles.title, { fontSize: 18, marginTop: 2 }]}>PREALABLE</Text>
        <Text style={styles.subtitle}>Informations préalables à l’admission</Text>
        <Text style={styles.subtitle}>des déchets inertes</Text>

        <View style={[styles.row, { marginTop: 14 }]}>
          <Text style={{ fontSize: 11, fontWeight: "bold" }}>Date :</Text>
          <View style={[styles.line, { maxWidth: 140 }]} />
          <Text style={[styles.red, { marginLeft: 18 }]}>A renvoyer à l’adresse mail suivante :</Text>
          <Text style={{ marginLeft: 6, textDecoration: "underline", color: "#0b57d0" }}>mansel@sem5962.fr</Text>
        </View>

        <View style={[styles.box, { marginTop: 14 }]}>
          <View style={styles.row}>
            <Text>Site de mise en décharge :</Text>
            <View style={{ width: 18 }} />
            <Check checked={d.site === "GRANDE_SYNTHE"} />
            <Text>GRANDE SYNTHE</Text>
            <View style={{ width: 18 }} />
            <Check checked={d.site === "LOON_PLAGE"} />
            <Text>LOON PLAGE</Text>
          </View>
        </View>

        {/* Chantier */}
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>➢  Information sur le chantier</Text>
          <View style={styles.sectionRule} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={styles.label}>Nom du chantier :</Text>
          <LineField value={d.chantier.nom} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={[styles.label, { width: 80 }]}>Adresse :</Text>
          <LineField value={d.chantier.adresse} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 28 }]}>CP :</Text>
          <LineField value={d.chantier.cp} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 70 }]}>Commune :</Text>
          <LineField value={d.chantier.commune} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={[styles.label, { width: 110 }]}>Contact Chantier :</Text>
          <LineField value={d.chantier.contact} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 22 }]}>@ :</Text>
          <LineField value={d.chantier.email} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={{ width: 122 }} />
          <Text style={[styles.smallLabel, { width: 42 }]}>Tél. :</Text>
          <LineField value={d.chantier.tel} />
        </View>

        {/* Producteur */}
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>➢  Producteur de déchet (Maître d’ouvrage)</Text>
          <View style={styles.sectionRule} />
        </View>

        {[
          ["Raison sociale :", d.producteur.raisonSociale],
          ["N° de SIRET :", d.producteur.siret],
        ].map(([lab, val]) => (
          <View key={lab} style={[styles.row, { marginTop: 6 }]}>
            <Text style={styles.label}>{lab}</Text>
            <LineField value={val} />
          </View>
        ))}

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={[styles.label, { width: 80 }]}>Adresse :</Text>
          <LineField value={d.producteur.adresse} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 28 }]}>CP :</Text>
          <LineField value={d.producteur.cp} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 70 }]}>Commune :</Text>
          <LineField value={d.producteur.commune} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={[styles.label, { width: 140 }]}>Personne à contacter :</Text>
          <LineField value={d.producteur.contact} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 22 }]}>@ :</Text>
          <LineField value={d.producteur.email} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={{ width: 152 }} />
          <Text style={[styles.smallLabel, { width: 42 }]}>Tél. :</Text>
          <LineField value={d.producteur.tel} />
        </View>

        {/* Demandeur */}
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>➢  Demandeur (entreprise chargée des travaux)</Text>
          <View style={styles.sectionRule} />
        </View>

        {[
          ["Raison sociale :", d.demandeur.raisonSociale],
          ["N° de SIRET :", d.demandeur.siret],
        ].map(([lab, val]) => (
          <View key={lab} style={[styles.row, { marginTop: 6 }]}>
            <Text style={styles.label}>{lab}</Text>
            <LineField value={val} />
          </View>
        ))}

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={[styles.label, { width: 80 }]}>Adresse :</Text>
          <LineField value={d.demandeur.adresse} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 28 }]}>CP :</Text>
          <LineField value={d.demandeur.cp} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 70 }]}>Commune :</Text>
          <LineField value={d.demandeur.commune} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={[styles.label, { width: 140 }]}>Personne à contacter :</Text>
          <LineField value={d.demandeur.contact} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 22 }]}>@ :</Text>
          <LineField value={d.demandeur.email} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={{ width: 152 }} />
          <Text style={[styles.smallLabel, { width: 42 }]}>Tél. :</Text>
          <LineField value={d.demandeur.tel} />
        </View>

        {/* Déchets */}
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>➢  Informations sur les déchets</Text>
          <View style={styles.sectionRule} />
        </View>
        <Text style={{ marginTop: 4 }}>Mettre une croix dans le tableau et quantité estimée</Text>

        <View style={styles.table}>
          <View style={[styles.tr, { borderBottomWidth: 1, borderBottomColor: "#000" }]}>
            <Text style={[styles.th, styles.cellCode]}>Code déchets</Text>
            <Text style={[styles.th, styles.cellDesc]}>Désignation déchets</Text>
            <Text style={[styles.th, styles.cellOui]}>Oui (x)</Text>
            <Text style={[styles.th, styles.cellQty]}>Quantités estimée (en T)</Text>
          </View>

          {d.dechets.map((r) => (
            <View key={r.code + r.designation} style={[styles.tr, { borderBottomWidth: 1, borderBottomColor: "#000" }]}>
              <Text style={[styles.td, styles.cellCode]}>{r.code}</Text>
              <Text style={[styles.td, styles.cellDesc]}>{r.designation}</Text>
              <View style={[styles.td, styles.cellOui]}><Text>{r.oui ? "X" : ""}</Text></View>
              <Text style={[styles.td, styles.cellQty]}>{r.quantite || ""}</Text>
            </View>
          ))}
        </View>
      </Page>

      {/* PAGE 2 */}
      <Page size="A4" style={styles.page}>
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>➢  Informations transporteurs (si plusieurs transporteurs joindre une annexe avec la liste)</Text>
          <View style={styles.sectionRule} />
        </View>

        {[
          ["Raison sociale :", d.transporteur.raisonSociale],
          ["N° de SIRET :", d.transporteur.siret],
        ].map(([lab, val]) => (
          <View key={lab} style={[styles.row, { marginTop: 6 }]}>
            <Text style={styles.label}>{lab}</Text>
            <LineField value={val} />
          </View>
        ))}

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={[styles.label, { width: 80 }]}>Adresse :</Text>
          <LineField value={d.transporteur.adresse} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 28 }]}>CP :</Text>
          <LineField value={d.transporteur.cp} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 70 }]}>Commune :</Text>
          <LineField value={d.transporteur.commune} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={[styles.label, { width: 140 }]}>Personne à contacter :</Text>
          <LineField value={d.transporteur.contact} />
          <Text style={{ width: 12 }} />
          <Text style={[styles.smallLabel, { width: 22 }]}>@ :</Text>
          <LineField value={d.transporteur.email} />
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <Text style={{ width: 152 }} />
          <Text style={[styles.smallLabel, { width: 42 }]}>Tél. :</Text>
          <LineField value={d.transporteur.tel} />
        </View>

        <View style={[styles.sectionHeader, { marginTop: 18 }]}>
          <Text style={[styles.sectionTitle, { color: "red" }]}>➢  Travaux parcelles bâtiments :</Text>
          <View style={styles.sectionRule} />
        </View>

        <Text style={{ marginTop: 8, fontSize: 11, fontWeight: "bold" }}>
          Si vos déblais sont issus de démolitions ou de terrassements dans une parcelle cadastrale bâtiment veuillez cocher la case correspondante :
        </Text>

        <View style={[styles.row, { marginTop: 10 }]}>
          <Check checked={d.travauxParcellesBatiments === true} />
          <Text style={{ fontSize: 11, fontWeight: "bold" }}>Oui</Text>
          <View style={{ width: 70 }} />
          <Check checked={d.travauxParcellesBatiments === false} />
          <Text style={{ fontSize: 11, fontWeight: "bold" }}>non</Text>
        </View>

        <View style={{ marginTop: 16 }}>
          <View style={styles.row}>
            <Text style={{ fontSize: 11, fontWeight: "bold" }}>
              Résultats d’analyse éventuellement joints (fournir une copie){" "}
            </Text>
            <Text style={[styles.red, { fontSize: 11 }]}>OBLIGATOIRE pour les déblais bitumeux.</Text>
          </View>

          <Text style={{ marginTop: 4, fontSize: 11 }}>
            Analyse fournie par le producteur (test lixiviation NF EN 12457-2)
          </Text>

          <View style={[styles.row, { marginTop: 10 }]}>
            <Check checked={d.analyse.fournie === true} />
            <Text style={{ width: 40 }}>oui</Text>
            <Text style={{ width: 80 }}>Analyse du :</Text>
            <LineField value={d.analyse.date} />
            <Text style={{ width: 30 }} />
            <Text style={{ width: 30 }}>Ref :</Text>
            <LineField value={d.analyse.ref} />
          </View>

          <View style={[styles.row, { marginTop: 8 }]}>
            <Check checked={d.analyse.fournie === false} />
            <Text style={{ width: 40 }}>non</Text>
          </View>
        </View>

        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>➢  Engagements</Text>
          <View style={styles.sectionRule} />
        </View>

        <Text style={{ marginLeft: 18, marginTop: 6 }}>
          Le producteur de déchets et le demandeur s’engagent à :
        </Text>

        {d.engagements.map((t, idx) => (
          <Text key={idx} style={{ marginLeft: 38, marginTop: 4 }}>
            - {t}
          </Text>
        ))}

        {/* Box Demandeur */}
        <View style={{ borderWidth: 1, borderColor: "#000", marginTop: 14 }}>
          <Text style={{ textAlign: "center", fontSize: 14, fontWeight: "bold", paddingTop: 8 }}>Demandeur</Text>
          <View style={{ flexDirection: "row", height: 90 }}>
            <View style={{ width: "35%", borderRightWidth: 1, borderRightColor: "#000", padding: 10 }}>
              <Text style={{ fontSize: 12 }}>Date :</Text>
            </View>
            <View style={{ flexGrow: 1, padding: 10 }}>
              <Text style={{ fontSize: 12 }}>Cachet Nom et signature :</Text>
            </View>
          </View>
        </View>

        {/* Green box */}
        <View style={{ marginTop: 12 }}>
          <View style={styles.row}>
            <Text style={{ fontSize: 12, fontWeight: "bold" }}>➢  Acceptation préalable de la plateforme de traitement </Text>
            <Text style={{ fontSize: 12, fontWeight: "bold", color: "red" }}>(cadre réservé à S.E.M)</Text>
          </View>
          <View style={styles.hr} />

          <View style={styles.greenBox}>
            <View style={{ flexDirection: "row", borderBottomWidth: 2, borderBottomColor: "#5aa04b" }}>
              <View style={{ width: "28%", borderRightWidth: 2, borderRightColor: "#5aa04b", padding: 10 }}>
                <Text style={{ fontSize: 11, fontWeight: "bold" }}>Date : ..................</Text>
              </View>
              <View style={{ flexGrow: 1, padding: 10 }}>
                <View style={styles.row}>
                  <Check checked={d.acceptationSem.oui === true} />
                  <Text>Oui obtention de </Text>
                  <Text style={{ color: "#5aa04b", fontWeight: "bold" }}>N° de CAP: {d.acceptationSem.noCap || "................................."}</Text>
                </View>
              </View>
            </View>

            <View style={{ flexDirection: "row", borderBottomWidth: 2, borderBottomColor: "#5aa04b" }}>
              <View style={{ width: "28%", borderRightWidth: 2, borderRightColor: "#5aa04b", padding: 10 }}>
                <Text>Nom du responsable</Text>
                <Text>admission plateforme de</Text>
                <Text>recyclage :</Text>
                <Text style={{ marginTop: 6 }}>.................................</Text>
              </View>

              <View style={{ flexGrow: 1, padding: 10 }}>
                <View style={styles.row}>
                  <Check checked={d.acceptationSem.oui === false} />
                  <Text style={{ fontWeight: "bold" }}>Non</Text>
                </View>

                <Text style={{ fontSize: 12, fontWeight: "bold", marginTop: 6 }}>Motif de refus acceptation :</Text>

                <View style={[styles.row, { marginTop: 6, flexWrap: "wrap" }]}>
                  <View style={{ width: "60%" }}>
                    <View style={styles.row}><Check checked={d.acceptationSem.motifs?.includes("SEUIL")} /><Text>Dépassement du seuil d’admission</Text></View>
                    <View style={[styles.row, { marginTop: 4 }]}><Check checked={d.acceptationSem.motifs?.includes("TECH")} /><Text>Impossibilité technique de réception</Text></View>
                  </View>
                  <View style={{ width: "40%" }}>
                    <View style={styles.row}><Check checked={d.acceptationSem.motifs?.includes("INTERDIT")} /><Text>Déchet interdit sur le site</Text></View>
                    <View style={[styles.row, { marginTop: 4 }]}><Check checked={d.acceptationSem.motifs?.includes("AUTRE")} /><Text>Autres : ........................</Text></View>
                  </View>
                </View>
              </View>
            </View>

            <View style={{ flexDirection: "row", height: 55 }}>
              <View style={{ width: "28%", borderRightWidth: 2, borderRightColor: "#5aa04b", padding: 10 }}>
                <Text style={{ fontSize: 12 }}>Signature</Text>
              </View>
              <View style={{ flexGrow: 1, padding: 10 }}>
                <Text style={{ fontSize: 12 }}>Cachet de la société S.E.M</Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}
